require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("bootstrap")
require("../src/care_home")
require("../src/price")
require("bootstrap")
import '@fortawesome/fontawesome-free/js/all'
import '../stylesheets/application.scss'

const images = require.context("../images", true);
const imagePath = name => images(name, true);
